import React, { useEffect, useState } from 'react';
import { applyActionCode } from 'firebase/auth';
import { auth } from './firebase';
import { useNavigate } from 'react-router-dom';
import './VerificadoPage.css';

function VerificadoPage() {
  const [mensagem, setMensagem] = useState('');
  const [status, setStatus] = useState('verificando'); // 'verificando', 'sucesso', 'erro'
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const oobCode = urlParams.get('oobCode');

    if (!oobCode) {
      setMensagem('Código inválido. Verificação falhou.');
      setStatus('erro');
      return;
    }

    applyActionCode(auth, oobCode)
      .then(() => {
        setMensagem('E-mail verificado com sucesso! Já podes fazer login.');
        setStatus('sucesso');
      })
      .catch((erro) => {
        console.error('Erro ao verificar e-mail:', erro);
        setMensagem('Este link de verificação já expirou ou é inválido.');
        setStatus('erro');
      });
  }, []);

  return (
    <div className="verificado-container">
      {status === 'verificando' && <p className="verificando">A verificar o teu e-mail...</p>}
      {status !== 'verificando' && (
        <>
          <p className={`mensagem-${status}`}>{mensagem}</p>
          <button onClick={() => navigate('/')}>Ir para Login</button>
        </>
      )}
    </div>
  );
}

export default VerificadoPage;